import React from "react";
import HeaderComponent from "../landingpage/header/HeaderComponent";
import "./styles/feature.css";
import FeatureCardLeft from "./featurecard/FeatureCardLeft";
import FeatureCardRight from "./featurecard/FeatureCardRight";
import bgDownArrow from "./assets/bg-down-arrow.svg";
import bgSpiral from "./assets/bg-spiral.svg";
import spiral_1 from "./assets/spiral_1.svg";
import FooterComponent from "../landingpage/footer/FooterComponent";
import {
features,
} from "./featureComponentData";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router";
import StickyButton from "../../components/generic/stickybutton/StickyButton";

const FeatureComponent = () => {
  const navigate = useNavigate()

  const handleNavigate = ()=>{
    navigate('/contact-us')
  }

  return (
    <>
      <Helmet>
        <title>Features | PDV– HIPAA-Compliant & EHR-Integrated</title>
        <meta name="description" content="From volunteer scheduling to real-time compliance tracking, PDV provides tools for automated workflows & secure documentation for hospices. Explore now!" />
        <meta property="og:title" content="Features | PDV– HIPAA-Compliant & EHR-Integrated" />
      </Helmet>
            <StickyButton />
    <section className="pdv-feature-page">
      <HeaderComponent />

      <div className="feature-container">
        <div className="feature-header">
          <h2 className="feature-heading">
            Empowering Hospices with Smarter Volunteer Program
          </h2>
          <p className="feature-subdescription">
          Comprehensive Tools for Streamlined Hospice Operations and Seamless Tracking.
          </p>
        </div>

        <div className="back-image-container">
          <div className="feature-icon-down-arrow">
            <img src={bgDownArrow} alt="bg-down-arrow"/>
          </div>
          <div className="feature-icon-spiral">
            <img src={bgSpiral} alt="bg-spiral"/>
          </div>
          <div className="feature-icon-spiral-1">
            <img src={spiral_1} alt="bg-spiral"/>
          </div>
          <div className="feature-section">
            {features.map((feature, index) =>
              index % 2 === 0 ? (
                <FeatureCardLeft key={index} {...feature} />
              ) : (
                <FeatureCardRight key={index} {...feature} />
              )
            )}
          </div>
        </div>
      </div>
      <div className="feature-demo">
        <p className="feature-demo-description">
          Have questions about our volunteer management solution or need
          assistance with getting started? We’re here to help! We are here to
          support you. Contact us to learn how our solution can simplify your
          work and improve your volunteer experience.
        </p>
        <button 
        className="feature-demo-btn" 
        onClick={handleNavigate}>
          Contact Us
          </button>
      </div>
      <FooterComponent />
    </section>
  </>
  );
};

export default FeatureComponent;